export const PCE_SERIAL_NUMBER_PATTERN = /^\d{3}$/
export const MIN_NAME_LETTERS = 3

export const countLetters = (value: string): number => (value.match(/\p{L}/gu) ?? []).length

export const isValidSerialNumber = (serialNumber: string): boolean =>
  PCE_SERIAL_NUMBER_PATTERN.test(serialNumber.trim())

export const hasEnoughNameLetters = (occupant: string): boolean => countLetters(occupant) >= MIN_NAME_LETTERS

export const canSearchWithName = ({ occupant, serialNumber }: { occupant: string; serialNumber: string }): boolean =>
  isValidSerialNumber(serialNumber) || hasEnoughNameLetters(occupant)

export const searchedParams = <T extends { occupant: string; serialNumber: string }>(params: T): T =>
  isValidSerialNumber(params.serialNumber ?? '') ? { ...params, occupant: '' } : params
